import React from "react";
import { Select } from "antd";

export const MatchTypeSelector = ({ selectedType, setSelectedType }) => (
    <Select
        style={{ width: "100%", height: "auto" }}
        rootClassName="custom-select"
        placeholder="Select Type"
        value={selectedType}
        onChange={setSelectedType}
        options={[
            { label: "Both", value: "match_count" },
            { label: "Exact", value: "exact_match_count" },
            { label: "Conceptual", value: "conceptual_match_count" },
        ]}
    />
);
